import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: String,
    url: String,
  }

  static targets = ["label"]

  async share(event) {
    event.preventDefault()

    const url = this.urlValue || window.location.href
    const title = this.titleValue || document.title

    if (navigator.share) {
      try {
        await navigator.share({ title, url })
        return
      } catch (e) {
        if (e.name === "AbortError") return
        // fall through to clipboard
      }
    }

    await navigator.clipboard.writeText(url)
    if (this.hasLabelTarget) {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = "Link copied!"
      setTimeout(() => (this.labelTarget.textContent = original), 2000)
    }
  }
}
